import { ConvexProvider, ConvexReactClient } from "convex/react";
import { ConvexAuthProvider } from "@convex-dev/auth/react";

// Force rebuild to use correct production URL: original-ferret-677.convex.cloud
const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

export { convex, ConvexProvider, ConvexAuthProvider };